import { Dispatch, SetStateAction, useState } from "react";

import { Column } from "@bridgesplit/ui";
import { AbfLoanExpanded, LoopPositionExpanded } from "@bridgesplit/abf-react";

import { ManualIncreaseLeverage } from "./ManualIncreaseLeverage";
import { ManualDecreaseLeverage } from "./ManualDecreaseLeverage";
import { ActionToggleButtons } from "./common";
import { getOptions } from "./util";
import { ManageLoanActions, ManualManageSubActions } from "../side-card/types";

export function ManualManageCard({
    loanExpanded,
    loopPosition,
    isNestedDialogView = false,
    setIsSwapOpen
}: {
    loanExpanded: AbfLoanExpanded | undefined;
    loopPosition: LoopPositionExpanded | undefined;
    isNestedDialogView?: boolean;
    setIsSwapOpen?: Dispatch<SetStateAction<boolean>>;
}) {
    const options = getOptions(ManageLoanActions.ManualManage);
    const [selectedAction, setSelectedAction] = useState<ManualManageSubActions>(options[0].value);

    return (
        <Column spacing={3}>
            <ActionToggleButtons
                value={selectedAction}
                setValue={setSelectedAction}
                options={options}
                isNestedDialogView={isNestedDialogView}
            />
            {selectedAction === ManualManageSubActions.ManualIncreaseLeverage && (
                <ManualIncreaseLeverage
                    loanExpanded={loanExpanded}
                    setIsSwapOpen={setIsSwapOpen}
                    loopPosition={loopPosition}
                />
            )}
            {selectedAction === ManualManageSubActions.ManualDecreaseLeverage && (
                <ManualDecreaseLeverage loanExpanded={loanExpanded} setIsSwapOpen={setIsSwapOpen} />
            )}
        </Column>
    );
}
